<template>
	<!-- 合同详情 -->
	<div class="wrapper">
		<div class="top-title">
			<span>合同凭证</span>
		</div>

		<div class="contract-wrap">
			<el-card shadow="hover">
				<div slot="header" class="clearfix">
					<span>E签宝合同</span>
				</div>
        <div class="signed-file-list">
          <el-button
              v-for="item in esignFileList"
              :key="item.fileUrl"
              type="primary"
              size="mini"
              @click="downloadContract(item)"
          >{{ item.fileName }}</el-button
          >
        </div>
			</el-card>
		</div>
	</div>
</template>

<script>
import { dateFormat } from "@/utils/index.js";
import { getContractDetailAPI, downloadPDF } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";

export default {
	name: "ContactDetail",
	mixins: [authBtnMixin],
	data() {
		return {
			dialogVisible: false,
			contractDetail: {},
		};
	},
	computed: {
		esignFileList() {
			let list = [];
			if (this.contractDetail.esignFileList) {
				list = this.contractDetail.esignFileList;
			}
			return list || [];
		},
	},
	mounted() {
		this.getContractDetail();
	},

	methods: {
		async getContractDetail() {
			this.contractDetail = await getContractDetailAPI(this.$route.params.id);
		},
		// 合同下载
		downloadContract(item) {
			const { fileName, fileUrl } = item;
			this.$confirm(`此操作将下载【${fileName}】, 是否继续?`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const name = `${
						this.$route.params.id
					}_${fileName}_${dateFormat()}.pdf`;
					downloadPDF(fileUrl, name);
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消操作",
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.top-title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15px;
}
.contract-item {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	span {
		margin: 10px 0;
		&:first-child {
			font-weight: 700;
		}
	}
}
.cert-item {
  margin-top: 20px;
  span {
    margin: 10px 0;
    &:first-child {
      font-weight: 700;
      margin-right: 20px;
    }
  }
}

.contract-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    & > div {
        width: calc((100% - 20px) / 2)
    }
}

.signed-file-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}
</style>
